import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokSpecialCampaignPosts.graphql';
import { Query, QuerytiktokSpecialCampaignPostsArgs } from '../../__generated__/globalTypes';

export const useTiktokSpecialCampaignPostsQuery = (
  options?: QueryHookOptions<Query, QuerytiktokSpecialCampaignPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokSpecialCampaignPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokSpecialCampaignPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokSpecialCampaignPostsArgs>
): QueryResult<Query, QuerytiktokSpecialCampaignPostsArgs> & {
  getTiktokSpecialCampaignPosts: LazyQueryExecFunction<Query, QuerytiktokSpecialCampaignPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokSpecialCampaignPosts, result] = useLazyQuery<Query, QuerytiktokSpecialCampaignPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokSpecialCampaignPosts, ...result };
};

export const useTiktokSpecialCampaignPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokSpecialCampaignPosts = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokSpecialCampaignPostsArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokSpecialCampaignPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokSpecialCampaignPosts };
};
// Suspense Query Hooks
export const useTiktokSpecialCampaignPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokSpecialCampaignPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokSpecialCampaignPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
